import DisclosureText from '@/frontend/features/Fde/investigations/DisclosureText'
import EvidenceValues from '@/frontend/features/Fde/investigations/EvidenceValues'
import type { BusinessEvidenceView, InvestigationLabels } from '@/frontend/features/Fde/investigations/types'

export default function BusinessEvidence({ view, copy }: { view: BusinessEvidenceView; copy: InvestigationLabels }) {
  // Rows are projected and authorized by Rails from evidence_id + row_indices.
  // Do not read executions/prose, calculate metrics, or guess missing values here.
  const available = Array.isArray(view.rows) && view.rows.length > 0 && view.columns.length > 0
  return <figure className="grid min-w-0 gap-3 rounded-lg bg-muted/35 p-4">
    <figcaption className="grid gap-1.5">
      <h4 className="text-sm font-medium">{view.title}</h4>
      {view.observation && <DisclosureText text={view.observation} textClassName="text-muted-foreground" expandLabel={copy.business_observation_expand} collapseLabel={copy.business_observation_collapse} />}
    </figcaption>
    {available ? <EvidenceValues key={JSON.stringify([view.evidence_id, view.row_indices, view.columns])} view={view} copy={copy} />
      : <p role="status" className="text-xs text-muted-foreground">{copy.business_evidence_unavailable}</p>}
    {view.context && <p className="text-xs leading-relaxed text-muted-foreground">{view.context}</p>}
    {(view.values_origin === 'document_journal' || view.values_origin === 'project_journal') && <p className="text-xs leading-relaxed text-muted-foreground">{copy.document_evidence_hint}</p>}
  </figure>
}
